export default [{
    path: '/taxes',
    name: 'taxes',
    component: () =>
        import ('@/views/pages/tax/tax-list/TaxList.vue'),
    meta: {
        pageTitle: 'Taxes',
        breadcrumb: [{
            text: 'Taxes',
            active: true,
        }, ],
        resource: 'tax',
        action: 'read',
    },
},
{
    path: '/taxes/view/:id',
    name: 'taxes-view',
    component: () =>
        import ('@/views/pages/tax/tax-view/TaxView.vue'),
    meta: {
        pageTitle: 'View Tax',
        breadcrumb: [
        {
            text: 'Taxes',
            to:'/taxes',
        }, 
        {
            text: 'View',
            active: true,
        }],
        resource: 'tax',
        action: 'read',
    },
},
{
    path: '/taxes/edit/:id',
    name: 'taxes-edit',
    component: () =>
        import ('@/views/pages/tax/tax-edit/TaxEdit.vue'),
    meta: {
        pageTitle: 'Edit Tax',
        breadcrumb: [
        {
            text: 'Taxes',
            to:'/taxes',
        }, 
        {
            text: 'Edit',
            active: true,
        }],
        resource: 'tax',
        action: 'read',
    },
},
{
    path: '/taxes/add',
    name: 'taxes-add',
    component: () =>
        import ('@/views/pages/tax/tax-add/TaxAdd.vue'),
    meta: {
        pageTitle: 'Add Tax',
        breadcrumb: [
            {
                text: 'Taxes',
                to:'/taxes',
            },
            {
                text: 'Add',
                active: true,
            }
        ],
        resource: 'tax',
        action: 'read',
    }
}
]